import { Badge } from 'react-bootstrap';
import { ApprovedIconSVG, DeniedIconSVG, PendingIconSVG } from './icons';
import './style.scss';

//variants : primary | secondary | warning | info | danger
//for border on the badge use 'badge-with-border' classname on host component

//to show pending badge icon use variant as info and prefix icon pending from host component
//to show approved badge icon use variant as primary and prefix icon approved from host component
//to show denied badge icon use variant as danger and prefix icon denied from host component

const IconMap = {
  pending: PendingIconSVG,
  approved: ApprovedIconSVG,
  denied: DeniedIconSVG,
};

export const BadgePill = ({
  text,
  className,
  variant = 'primary',
  prefixIcon,
}) => {
  let Icon;
  if (prefixIcon) {
    Icon = IconMap[prefixIcon];
  }
  return (
    <Badge
      variant={variant}
      className={className ? 'badge-pill ' + className : 'badge-pill'}
    >
      {/*{prefixIcon && prefixIcon}&nbsp; {text} */}
      {Icon && <Icon />}&nbsp; {text}
    </Badge>
  );
};
